const ChatWithUs = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M23.5 18.488V3h-22v15.488l7.194.011 3.794 2.492 3.5-2.492 7.512-.01Zm-8.005-1.454V17L22 16.99V4.5H3v12.49l6.164.01v.014l3.29 2.16 3.03-2.157.011.017Z"
      clipRule="evenodd"
    />
  </svg>
);
export default ChatWithUs;
